<template>
  <main-title>Мои проекты</main-title>
  <horizontal-filter>
    <template #default>
      <filter-item hash="#new" text="Новые проекты" />
      <filter-item hash="#inwork" text="В работе" />
      <filter-item hash="#archive" text="Архив" />
    </template>
    <template #right>
      <label class="panel__total-projects" v-if="totalProjects">
        Всего: {{ totalProjects }}
      </label>
    </template>
  </horizontal-filter>
  <projects-filter :status-list="statusList" @update-filter="updateFilter" />
  <infinite-grid-layout
    :get-items="api.project.projectStats"
    :url-params="urlParams"
    :scroll-bottom="scrollBottom"
    entity="projects"
    @update-total-count="
      (count) => {
        totalProjects = count;
      }
    "
  >
    <template #table-item="slotProps">
      <router-link :to="getLink(slotProps.item)">
        <project-card :project="slotProps.item" />
      </router-link>
    </template>
  </infinite-grid-layout>
</template>

<script setup>
  import { computed, onMounted, ref, watch } from 'vue';
  import { useRoute } from 'vue-router';
  import { useApi } from '@/api/use-api';
  import MainTitle from '@/components/titles/MainTitle';
  import HorizontalFilter from '@/components/filter/horizontal/HorizontalFilter';
  import FilterItem from '@/components/filter/components/FilterItem';
  import ProjectsFilter from '@/components/projects/components/ProjectsFilter.vue';
  import ProjectCard from '@/components/projects/components/ProjectCard.vue';
  import {
    PROJECT_STATUS_ACCEPTANCE,
    PROJECT_STATUS_AGREEMENT,
    PROJECT_STATUS_IN_WORK,
  } from '@/api/models/ProjectStatus';
  import {
    PROJECT_TAB_IN_WORK,
    PROJECT_TAB_NEW,
  } from '@/constants/project-tab';
  import {
    PROJECT_STATUS_NAME_ACCEPTANCE,
    PROJECT_STATUS_NAME_AGREEMENT,
  } from '@/constants/project-status';
  import InfiniteGridLayout from '@/components/infinite-grid/InfiniteGridLayout.vue';

  defineProps({
    scrollBottom: Number,
  });

  const api = useApi();
  const route = useRoute();
  const urlParams = ref(null);
  const totalProjects = ref(0);

  const statusList = computed(() => {
    const tab = route.hash ? route.hash.replace('#', '') : PROJECT_TAB_IN_WORK;
    switch (tab) {
      case PROJECT_TAB_NEW:
        return [PROJECT_STATUS_NAME_AGREEMENT, PROJECT_STATUS_NAME_ACCEPTANCE];
      // TODO Раскомментировать, когда будет добавлен поиск по виртуальному статусу "rejected"
      // case PROJECT_TAB_ARCHIVE:
      //   return [PROJECT_STATUS_NAME_CLOSED, PROJECT_STATUS_NAME_REJECTED];
      default:
        return [];
    }
  });

  onMounted(() => {
    urlParams.value = new URLSearchParams({
      tab: route.hash ? route.hash.replace('#', '') : PROJECT_TAB_IN_WORK,
      role: route.meta.role,
    });

    if (route.query.textSearch) {
      urlParams.value.set('textSearch', route.query.textSearch);
    }
  });

  watch(
    () => route.hash,
    async () => {
      updateFilter(new URLSearchParams([...urlParams.value]));
    }
  );

  const updateFilter = (filterParams) => {
    filterParams.set(
      'tab',
      route.hash ? route.hash.replace('#', '') : PROJECT_TAB_IN_WORK
    );
    urlParams.value = filterParams;
  };

  const getLink = (project) => {
    if (project.projectStatusId === PROJECT_STATUS_AGREEMENT) {
      return `/administrator/project/` + project.id + `/form#10`;
    } else if (project.projectStatusId === PROJECT_STATUS_ACCEPTANCE) {
      return `/administrator/project/` + project.id + `/agreement`;
    } else if (project.projectStatusId === PROJECT_STATUS_IN_WORK) {
      return `/administrator/project/` + project.id + `/management`;
    } else {
      return `/administrator/project/` + project.id + `/form`;
    }
  };
</script>

<style lang="scss" scoped></style>
